module.exports = __webpack_public_path__ + "img/ic_visa_on_arrival.66bef477.png";